module.exports = __webpack_public_path__ + "static/media/save-money.8347acb2.svg";